export default "__VITE_ASSET__94894623__"